import PropTypes from "prop-types";
import React from "react";

const BowlineWalletConnectInfo = (_props, context) => {
  return (
    <div className="px-lg-5">
      <p className="h5 text-center fw-bold mb-4">
        {context.t("How to connect?")}
      </p>
      <p className="text-center text-muted">
        {context.t(
          "To securely connect and interact with this service you need to have a wallet that supports the Web3 protocol. Please select one of the following options to connect to your wallet."
        )}
      </p>
      <p className="h5 text-center fw-bold mb-4 mt-5">
        {context.t("I do have a wallet.")}
      </p>
      <p className="text-center text-muted">
        {context.t(
          "In case you do already have a wallet, please select MetaMask, Ledger, Coinbase or Wallet Connect to connect to your wallet."
        )}
      </p>
      <p className="h5 text-center fw-bold mb-4 mt-5">
        {context.t("No wallet yet?")}
      </p>
      <p className="text-center text-muted">
        {context.t(
          "No problem, you have the convenience of creating a personal wallet effortlessly by utilizing your social network accounts. We'll create a non-custodial wallet for you in the background and you can export your private keys if required."
        )}
      </p>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
BowlineWalletConnectInfo.contextTypes = {
  t: PropTypes.func,
};

export default BowlineWalletConnectInfo;
